/**
 * @file ReturnStagesPage.tsx
 * @description «Стадии возвратов» — раздел «Настроек» (phase10.5 шаг 3;
 * phase19.31 — общий редактор `StageListEditor`, компактный список).
 *
 * Зеркало «Стадий заказов»: тот же редактор, свои данные — стадии воронки
 * возвратов, счётчик «N возвратов», своё окно правки (виды стадий возврата).
 */

import { useParams } from "react-router";

import { useHasPermission } from "../../../auth/hooks";
import { ReturnStageEditDialog } from "../../../components/orders/ReturnStageEditDialog";
import type { StageListConfig } from "../../../components/orders/stages/stage-list-types";
import { StageListEditor } from "../../../components/orders/stages/StageListEditor";
import {
  deleteReturnStage,
  listReturnPipelines,
  listReturnStages,
  reorderReturnStages,
  type ReturnStageConfigDto,
} from "../../../lib/api-returns";

const RETURN_STAGES: StageListConfig<ReturnStageConfigDto> = {
  title: "Стадии возвратов",
  countOf: (stage) => stage.returnsCount,
  countWords: ["возврат", "возврата", "возвратов"],
  load: async (pipelineId) => {
    const [pipelines, stages] = await Promise.all([listReturnPipelines(), listReturnStages(pipelineId)]);
    return { pipelineName: pipelines.find((p) => p.id === pipelineId)?.name ?? null, stages };
  },
  reorder: reorderReturnStages,
  remove: deleteReturnStage,
  renderDialog: ({ pipelineId, state, onClose, onSaved }) => (
    <ReturnStageEditDialog
      mode={state.mode}
      pipelineId={pipelineId}
      stage={state.mode === "edit" ? state.stage : undefined}
      onClose={onClose}
      onSaved={onSaved}
    />
  ),
};

export function ReturnStagesPage() {
  const { pipelineId } = useParams<{ pipelineId: string }>();
  // Права — как у прежней страницы: стадии возвратов настраивает менеджер заказов.
  const canConfig = useHasPermission("SHOP_MANAGE_ORDERS");
  return <StageListEditor config={RETURN_STAGES} pipelineId={pipelineId} canConfig={canConfig} />;
}
